import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';
import Pagination from "react-js-pagination";
import $ from 'jquery';
import AcademicPage from '../../views/AcademicPage/';
const GLOBAL = require('../../Globals');

class Transfer extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			accyear : [],
			acyear : '',
			posts: [],
			postFilter : [],
			_redirect : false,
			_redirectView : false,
			currentPage: 1,
			todosPerPage: 20,
			activePage : 1,
			stdname : '',
			stdregno : '',
			data : [],
			cls : '',
			section : ''
		}
		this.basestate = this.state;
		this.handlePageChange = this.handlePageChange.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
		this.onBack = this.onBack.bind(this);
		this.onSearchChange = this.onSearchChange.bind(this);
		this.onRegnoSearchChange = this.onRegnoSearchChange.bind(this);
		this.onShowChange = this.onShowChange.bind(this);
		this.onChange = this.onChange.bind(this);
		this.onView = this.onView.bind(this);
	}
	
	onChange(e){
		
		this.setState({[e.target.name]:e.target.value});
		console.log(this.state);
		this.getdata();
	}
	
	onShowChange(e){
		this.state.todosPerPage = e.target.value;
		console.log(this.state);
		this.getdata();
		this.filterdata();
	}

	onSearchChange(e){
		
		this.state.stdname = e.target.value;
		this.filterdata();
	}
	
	onRegnoSearchChange(e){
		
		this.state.stdregno = e.target.value;
		this.filterdata();
	}
	
	handlePageChange(pageNumber) {
		
		this.setState({activePage: pageNumber});
		this.state.currentPage = Number(pageNumber);
	}
	
	onBack(e){
		
		this.setState({_redirect : true});
	}
	
	/** this function will be call when page loading **/
	componentWillMount(){
		
		this.getdata();
		this.gettransdata();
		console.log(this.state);
	}
	
	gettransdata(){
		$("#showLoader").show();
		GetData('certificate/gettransfer').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					data : responseJson
				});
			}
		});
	}
	
	getdata(){
		$("#showLoader").show();
		this.setState({posts : []});
		GetData('student/gettransferstudent').then((result) => {
				$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson,
					postFilter : responseJson
				});
				$('#show option').eq(1).prop('selected', true).trigger('change');
			}
		});
	}
	
	onUpdate(dt){
		
		this.state.idd = dt;
			$("#showLoader").show();
		PostData('certificate/addtransfer',this.state).then((result) => {
				$("#showLoader").hide();
			let responseJson = result;
			if(responseJson.status == '1' ){
				this.setState({_redirect: true});
			}
			else{
				
				this.getdata();
			}
		});
	}
	
	onView(dt){
		
		this.state.idd = dt;
		this.setState({_redirectView: true});
	}
	
	filterdata(){
		
		this.state.postFilter = [];
		var dat = [];
		for(var i=0; i<this.state.posts.length; i++){
			
			if(this.state.stdname!=''){
				if(this.state.posts[i].stdname.toLowerCase().search(this.state.stdname.toLowerCase()) !=-1){
				
					dat.push(this.state.posts[i]);
				}
			}
			else if(this.state.stdregno!=''){
				
				if(this.state.posts[i].regno == this.state.stdregno){
					
					dat.push(this.state.posts[i]);
				}
			}
		}
		this.setState({postFilter : dat});
	}
	
  render() {
	
	if(this.state._redirect){
		  
		return (<Redirect to={'/academic/certificate/edittransfer/'+ this.state.idd} />);

	}
	
	if(this.state._redirectView){
		
		return (<Redirect to={'/academic/certificate/viewtransfer/'+ this.state.idd} />);
	}
	
	/** set showcount select box **/
	this.shows = [
		{value : '10', name : '10'},
		{value : '20', name : '20'},
		{value : '50', name : '50'},
		{value : '100', name : '100'}
	];
	
	// Logic for displaying current todos
	const indexOfLastTodo = this.state.currentPage * this.state.todosPerPage;
	const indexOfFirstTodo = indexOfLastTodo - this.state.todosPerPage;
	const currentTodos = this.state.postFilter.slice(indexOfFirstTodo, indexOfLastTodo);

	const renderTodos = currentTodos.map((item,i) => {
		
		return <tr key = {item}>
			<td width="50" className="tablewidth">{i+1}</td>
			<td width="250">{item.regno}</td>
			<td width="250">{item.admissionno}</td>
			<td width="500">{item.stdname}</td>
			<td width="150">{item.cls}</td>
			<td width="100">{item.sec}</td>
			<td width="200">{item.mobile}</td>
			<td width="200">
				<button name="edit" className="btn btn-info btn-sm" onClick={() => this.onUpdate(item.regno)} ><i className="fa fa-edit"></i></button>
			</td>
		</tr>;
		
	});
	
    return (
		<div>
		  <AcademicPage />
			<div className="animated fadeIn">
				<div className={this.state.alertClass}>
					{this.state._message}
				</div>
				<Row>
				  <Col md="12">
				   <Card>
					<CardHeader>
						<strong>Student List</strong>&nbsp;&nbsp;
							Reg No : &nbsp;&nbsp;
								<input type="text" name="stdregno" onChange={this.onRegnoSearchChange} />&nbsp;&nbsp;
							Name : &nbsp;&nbsp;
								<input type="text" name="stdname" onChange={this.onSearchChange} />&nbsp;&nbsp;
							Total Students : <span>{this.state.postFilter.length}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
							show &nbsp;
								<select name="show" onChange={this.onShowChange} id="show" >
									{this.shows.map((e, key) => {
										return <option key={key} value={e.value}>{e.name}</option>;
									})}	
								 </select>&nbsp;
							entries
					</CardHeader>
					<CardBody>
						<Table responsive striped>
						<thead>
							<tr>
								<th width="50" className="tablewidth">S.No</th>
								<th width="250">Reg No</th>
								<th width="250">Admission No</th>
								<th width="500">Student Name</th>
								<th width="150">Class</th>
								<th width="100">Section</th>
								<th width="200">Mobile</th>
								<th width="150">Manage</th>
							</tr>
						</thead>
						<tbody>
							{renderTodos}
							<br></br>
							<Pagination
								 activePage={this.state.activePage}
								 itemsCountPerPage={this.state.todosPerPage}
								 pageRangeDisplayed={3}
								 totalItemsCount={this.state.postFilter.length}
								 onChange={this.handlePageChange}
								/>
						</tbody>
					 </Table>
					</CardBody>
				   </Card>
				  </Col>
				</Row>
			</div>
		</div>
	)
  }
}

export default Transfer;


// WEBPACK FOOTER //
// ./src/certificate/Transfer/Transfer.js